<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

defineEmits(['create']);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center justify-center px-6 py-14 text-center">
    <h2 class="text-base font-semibold text-n-slate-12">
      {{ title || t('TASKS.EMPTY_TITLE') }}
    </h2>
    <p class="mt-1 max-w-xs text-sm leading-6 text-n-slate-11">
      {{ description || t('TASKS.EMPTY_DESCRIPTION') }}
    </p>
    <Button
      class="mt-5"
      icon="i-lucide-plus"
      :label="t('TASKS.CREATE')"
      @click="$emit('create')"
    />
  </div>
</template>
